import React from 'react';

const AsyncRadioClipPage = React.lazy(() => import('./RadioClipContainer'));

export const RadioClipPage = () => {
  return <AsyncRadioClipPage />;
};
